/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import * as firebase from 'firebase/app';
import { rolesType } from './utils/constants';

export async function isAdmin(role) {
  return role.includes(rolesType.admin);
}

export async function isSampler(role) {
  return role.includes(rolesType.sampler);
}

export async function isTechnician(role) {
  return role.includes(rolesType.patient);
}

export async function getUserRoles(userId) {
  const user = userId || await firebase.auth().currentUser.uid;
  const userRoles = [];

  // Try for admin role.
  if (await tryRole(user, rolesType.admin)) {
    userRoles.push(rolesType.admin);
  }

  // Try for sampler role.
  if (await tryRole(user, rolesType.sampler)) {
    userRoles.push(rolesType.sampler);
  }

  // Try for technician role.
  if (await tryRole(user, rolesType.technician)) {
    userRoles.push(rolesType.technician);
  }

  // Patients does not require any special privileges.
  return userRoles;
}

async function tryRole(user, role) {
  const db = firebase.firestore();

  // Try to get user document on `role`.
  try {
    const docSnapshot = await db.collection('roles').doc(role).collection('users').doc(user)
      .get();
    return docSnapshot.exists;
  } catch (error) {
    // User it not allow to read this role (patients can't read admin doc).
    return false;
  }
}
